import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { LoginModel } from '../../models/login.model';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TokenStorageService } from '../../services/token-storage.service';
import { AppToastService } from '../../services/app-toast.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpStatus, RolesType } from './../../models/model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  constructor(private router: Router,
              private authService: AuthService,
              private formBuilder: UntypedFormBuilder,
              private tokenStorageService: TokenStorageService,
              private toastService: AppToastService,
              private translate: TranslateService) { }

  loginModel: LoginModel;
  loginForm: UntypedFormGroup;
  submitted = false;

  formErrors = {
    username: '',
    password: '',
  };

  validationMessage = {
    username: {
      required: 'common.request.request',
    },
    password: {
      required: 'common.request.request',
    }
  };

  ngOnInit() {
    this.loginModel = new LoginModel();
    this.buildForm();
  }

  onSubmit() {
    this.loginModel = this.loginForm.value;
    if (this.loginForm.valid) {
      this.authService.login(this.loginModel).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          console.log(res);
          if (res.status === HttpStatus.OK) {
            this.tokenStorageService.saveToken(res.data.token);
            sessionStorage.setItem('current_user', JSON.stringify(res.data));
            this.authService.auth = res.data;
            if (res.data.defaultPage) {
              this.router.navigateByUrl(res.data.defaultPage);
            } else {
              this.router.navigateByUrl('/');
            }
          } else {
            this.toastService.error(this.translate.instant('common.label.error'), res.messages);
            this.router.navigateByUrl('/login');
          }
        },
        error: (error) => {
          this.toastService.error(this.translate.instant('common.label.error'), this.translate.instant('common.messages.error'));
          this.router.navigateByUrl('/login');
        }
      });
    }
    this.submitted = true;
    this.onValueChange();
  }

  buildForm() {
    this.loginForm = this.formBuilder.group({
      username: [this.loginModel.username, Validators.required],
      password: [this.loginModel.password, Validators.required],
      remember: [this.loginModel.remember]
    });
    this.loginForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
      next: (data) => this.onValueChange(data)
    });
    this.onValueChange();
  }

  get f() {
    return this.loginForm.controls;
  }

  onValueChange(data?: any) {
    if (!this.loginForm) { return; }
    const form = this.loginForm;

    for (const field in this.formErrors){
      this.formErrors[field] = '';
      const control = form.get(field);
      if ((control && control.dirty && !control.valid) || (this.submitted && control.invalid)){
        const message = this.validationMessage[field];
        for (const key in control.errors) {
          this.formErrors[field] += message[key] + '';
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
